import { render, staticRenderFns } from "./AppTouch.vue?vue&type=template&id=1b482f00&scoped=true&"
import script from "./AppTouch.vue?vue&type=script&lang=ts&"
export * from "./AppTouch.vue?vue&type=script&lang=ts&"
import style0 from "./AppTouch.vue?vue&type=style&index=0&id=1b482f00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b482f00",
  null
  
)

component.options.__file = "AppTouch.vue"
export default component.exports